import { render } from "./Villager.vue?vue&type=template&id=2eb2940e&scoped=true"
import script from "./Villager.vue?vue&type=script&lang=js"
export * from "./Villager.vue?vue&type=script&lang=js"

import "./Villager.vue?vue&type=style&index=0&id=2eb2940e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb2940e"]])

export default __exports__